import { render, staticRenderFns } from "./TableCode.vue?vue&type=template&id=19c38c98&"
import script from "./TableCode.vue?vue&type=script&lang=js&"
export * from "./TableCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports